<template>
	<div class="Home">
		<navbarv2 />

        <div class="container-fluid" style="padding-top: 6rem; margin-left: 25px; margin-right: 25px;">
            <!-- <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item>Sitemap</el-breadcrumb-item>
            </el-breadcrumb> -->
            <h2 class="title mb-4">SITEMAP</h2>

            <ul class="list">
                <li class="list-item">
                    <router-link tag="a" to="/" exact>Home</router-link>
                </li>
                <li class="list-item">
                    <router-link tag="a" to="/about-us" exact>About Us</router-link>
                </li>
                <li class="list-item">
                    <a href="javascript:void(0)">Solutions</a>
                </li>
                <ul class="list">
                    <li class="list-sub-item">
                        <router-link to="/ai-forecasting-and-reco-engine" exact tag="a">Forecasting and Recommendation Engine</router-link>
                    </li>
                    <li class="list-sub-item">
                        <router-link to="/workforce-scheduling" exact tag="a">Workforce Management and Scheduling</router-link>
                    </li>
                    <li class="list-sub-item">
                        <router-link to="/demand-planning" exact tag="a">Demand Planning</router-link>
                    </li>
                </ul>
                <li class="list-item">
                    <router-link to="/terms-of-service" exact tag="a">Terms of Service</router-link>
                </li>
                <li class="list-item">
                    <router-link to="/privacy-policy" exact tag="a">Privacy Policy</router-link>
                </li>
            </ul>
        </div>
	</div>
</template>

<script>
import RequestDemoBar from "../../components/requestDemoBar/RequestDemoBar.vue";
export default {
	name: "Sitemap",
	components: {
		"request-demo-bar": RequestDemoBar,
	},
    computed: {
		showLoginModel() {
			return this.$store.state.show_login_and_freeTrial_model;
		}
	},
    methods: {
		goToFreeTrial() {
			this.$store.commit("showFreeTrialModel", true);
			this.$store.commit("openLoginModel", true);
		},
		redirectToTargetPage(page_name) {
			this.$router.push({ path: page_name }).catch(()=>{});
		}
	}
};
</script>

<style lang="scss" scoped>
.list {
    list-style: none;
    .list-item {
        margin-top: 0.6rem;
            a {
            text-decoration: none;
            color: #d26300;
        }
    }
    .list-item::before {
        content: "\2022";
        color: #d26300;
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }
    .list-sub-item::before {
        content: "\2010";
        color: #d26300;
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }
    .list-sub-item {
        margin-top: 0.6rem;
            a {
            text-decoration: none;
            color: #d26300;
        }
    }
}
</style>
